import {
	AppstoreAddOutlined,
	CheckCircleOutlined,
	CreditCardOutlined,
	DatabaseOutlined,
	DeleteOutlined,
	FileAddOutlined,
	FileDoneOutlined,
	FileOutlined,
	FileProtectOutlined,
	FileTextOutlined,
	FlagFilled,
	FlagOutlined,
	FolderOpenOutlined,
	HomeOutlined,
	IdcardOutlined,
	InboxOutlined,
	NotificationFilled,
	PieChartOutlined,
	PlusCircleOutlined,
	ProfileOutlined,
	ProjectFilled,
	ProjectOutlined,
	SafetyOutlined,
	ScheduleOutlined,
	SettingOutlined,
	SolutionOutlined,
	TransactionOutlined,
	TrophyFilled,
	UserDeleteOutlined,
	UserOutlined,
	UserSwitchOutlined,
	UsergroupAddOutlined,
	WalletOutlined,
	ClusterOutlined,
	PlusOutlined,
	AppstoreOutlined,
	TeamOutlined,
	StarOutlined,
	AimOutlined,
	EditOutlined,
	HistoryOutlined,
	ShareAltOutlined,
	ApartmentOutlined,
	// AppstoreOutlined
} from "@ant-design/icons";
import { Menu } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import styles from "./Sidenav.module.css";
import { GetAllPermission, GetPermissionsRoleId } from "../../redux/rtk/features/permission/permissionSlice";
import getRoleIdFromToken from "../../utils/getRoleIdByToken";

// Icon mapping object
const iconMap = {
	ApartmentOutlined: <ApartmentOutlined />,
	FileTextOutlined: <FileTextOutlined />,
	HomeOutlined: <HomeOutlined />,
	ShareAltOutlined: <ShareAltOutlined />,
	UserOutlined: <UserOutlined />,
	UsergroupAddOutlined: <UsergroupAddOutlined />,
	DeleteOutlined: <DeleteOutlined />,
	SolutionOutlined: <SolutionOutlined />,
	IdcardOutlined: <IdcardOutlined />,
	ProfileOutlined: <ProfileOutlined />,
	FileDoneOutlined: <FileDoneOutlined />,
	WalletOutlined: <WalletOutlined />,
	CreditCardOutlined: <CreditCardOutlined />,
	PieChartOutlined: <PieChartOutlined />,
	TransactionOutlined: <TransactionOutlined />,
	DatabaseOutlined: <DatabaseOutlined />,
	AppstoreAddOutlined: <AppstoreAddOutlined />,
	InboxOutlined: <InboxOutlined />,
	SafetyOutlined: <SafetyOutlined />,
	NotificationFilled: <NotificationFilled />,
	FlagFilled: <FlagFilled />,
	TrophyFilled: <TrophyFilled />,
	ClusterOutlined: <ClusterOutlined />,
	PlusOutlined: <PlusOutlined />,
	AppstoreOutlined: <AppstoreOutlined />,
	TeamOutlined: <TeamOutlined />,
	StarOutlined: <StarOutlined />,
	AimOutlined: <AimOutlined />,
	EditOutlined: <EditOutlined />,
	HistoryOutlined: <HistoryOutlined />,
	UserDeleteOutlined: <UserDeleteOutlined />,
	PlusCircleOutlined: <PlusCircleOutlined />,
	CheckCircleOutlined: <CheckCircleOutlined />,
	FolderOpenOutlined: <FolderOpenOutlined />,
	ProjectOutlined: <ProjectOutlined />,
	ProjectFilled: <ProjectFilled />,
	SettingOutlined: <SettingOutlined />,
	UserSwitchOutlined: <UserSwitchOutlined />,
	ScheduleOutlined: <ScheduleOutlined />,
	FlagOutlined: <FlagOutlined />,
	FileProtectOutlined: <FileProtectOutlined />,
	FileOutlined: <FileOutlined />,
	FileAddOutlined: <FileAddOutlined />,
	FileTextOutlined: <FileTextOutlined />
};

const Sidenav = ({ color, sideNavOpenKeys }) => {
	const [isOnboardingComplete, setIsOnboardingComplete] = useState(true);
	const [menuData, setMenuData] = useState([]);
	const user = getUserFromToken();
	const dispatch = useDispatch();
	const { list: onboardingData } = useSelector((state) => state.setUp);
	 const permissions = useSelector((state) => state.permission.permission); // update based on your slice
	 const permissionsByRoleId = useSelector((state) => state.permission.permissionByRole); // update based on your slice
// console.log("permissionsByRoleId", permissionsByRoleId);
const RequirePasswordChange = localStorage.getItem("RequirePasswordChange");
  // console.log("passwordChanged", RequirePasswordChange);

const RoleId = getRoleIdFromToken()
	// const permissions = getPermissions();
const BASE_URL =
  process.env.REACT_APP_API?.replace(/^["']|["']$/g, '') || "https://hrmsapi.softomation.com";

	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};

	// Recursive function to transform menu items
const transformMenuItem = (item) => ({
	...item,
	label: item.path ? (
		<NavLink to={item.path} className={styles.menuLabel}>
			<span>{item.label}</span>
		</NavLink>
	) : (
		<span className={styles.menuLabel}>{item.label}</span>
	),
	icon: iconMap[item.icon] || null,
	children: item.children ? item.children.map(transformMenuItem) : undefined
});


	useEffect(() => {
		const lastProject = localStorage.getItem('lastProject');
		if (lastProject === 'erp') {
			const savedState = localStorage.getItem('sharedState');
			if (savedState) {
				try {
					const parsedState = JSON.parse(savedState);
				} catch (error) {
					// console.error('Error parsing shared state:', error);
				}
			}
		}
	}, []);

	useEffect(() => {
		const fetchOnboardingProgress = async () => {
			try {
				const companyId = getCompanyIdFromToken();
				if (!companyId) {
					return;
				}

				const response = await axios.get(`/initialSetUp/onboarding-progress?companyId=${companyId}`);
				const allCompleted = response.data.every(step => step.completed);
				setIsOnboardingComplete(allCompleted);
			} catch (error) {
				// console.error('Error fetching onboarding progress:', error);
			}
		};

		fetchOnboardingProgress();
	}, []);

	// Fetch menu data from API
	// useEffect(() => {
	// 	const fetchMenuData = async () => {
	// 		try {
	// 			const response = await axios.get(`${BASE_URL}/roles/GetMenuDetails`); // Adjust API endpoint as needed
	// 			const apiMenuData = response.data;
	// 			const transformedMenu = apiMenuData.map(transformMenuItem);
				

	// 			setMenuData(transformedMenu);
	// 		} catch (error) {
	// 			// console.error('Error fetching menu data:', error);
	// 		}
	// 	};

	// 	fetchMenuData();
	// }, [isOnboardingComplete]);

  useEffect(() => {
    if (isOnboardingComplete) {
      dispatch(GetAllPermission());
	  dispatch(GetPermissionsRoleId(RoleId));
    }
  }, [dispatch, isOnboardingComplete]);

  useEffect(() => {
    if (permissions) {
      const transformedMenu = permissions.map(transformMenuItem);
      setMenuData(transformedMenu);
    }
  }, [permissions]);

	return (
		<div>
			{RequirePasswordChange !== "true" && (
			<Menu
				theme='dark'
				mode='inline'
				items={menuData}
				className='sidenav-menu'
			/>
			)}
			{/* <div 
				className="px-4 flex items-center justify-between font-Popins hover:bg-[rgb(24,144,255)] py-3 cursor-pointer text-white"
				onClick={() => {
					localStorage.setItem('lastProject', 'hrm');
					window.location.href = 'http://erp.softomation.com/admin/dashboard';
				}}
			>
				<span className="flex items-center gap-1">
					<AppstoreOutlined /> Switch to ERP
				</span>
				<AppstoreOutlined />
			</div> */}
		</div>
	);
};

export default Sidenav;